import React, { Component, useState, useContext, useRef, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Collapse, Button,Row,Col } from 'reactstrap';
import {FaFileImport, FaLink, FaWarehouse, FaNewspaper, FaRegBuilding, FaStaylinked, FaRegUserCircle, FaDoorOpen, FaChevronDown, FaChevronUp, FaHome, FaKey,FaBell,FaCog } from 'react-icons/fa';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faGear, faUser, faCaretDown, faCaretUp, faRightFromBracket, faIndustry, faLink, faNewspaper } from '@fortawesome/free-solid-svg-icons'
import useAuth from "../Utilities/Hooks/useAuth";
import './Profile.css';
import jwt_decode from "jwt-decode";
import { apiGet } from "../Utilities/Hooks/apiWrapper";

library.add(faGear, faUser, faCaretDown, faCaretUp, faRightFromBracket, faIndustry, faLink, faNewspaper)

const Profile = () => {

    const { auth, setAuth } = useAuth();
    const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId"));
    const navigate = useNavigate();
    const [caretDown, setCaretDown] = useState(true);
    const [menuOpen, setMenuOpen] = useState(false);
    const [user, setUser] = useState({});
    const [role, setRole] = useState({});    
    const [buttonWidth, setButtonWidth] = useState("12.5vw");
    const nameRef = useRef(null);
    const [pageSettingsAccess, setPageSettingsAccess] = useState(false);
    const [tcAccepted, setTCAccepted] = useState(false);
    useEffect(() => {
        const currentUser = localStorage.getItem("auth");
        currentUser != null ? setUser(JSON.parse(currentUser)) : setUser({});

        if (auth != null) {
            var decodedToken = jwt_decode(auth.token);
            setRole(decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
            setPageSettingsAccess(auth.pageSettingsAccess);
        }

        if (nameRef.current) {
            const nameWidth = nameRef.current.offsetWidth;
            const padding = 80; // account for icon & margins (adjust as needed)
            setButtonWidth(`${nameWidth + padding}px`);
        }
        OnPageload();       

    }, [user.fullName]);

    const OnPageload = async (e) => {
        try {
            const response = await apiGet(
                '/api/settings/GetTCAcceptedInfo/', {
                params: { UserId: userId }
            }
            );
            if (response.data.status) {
                setTCAccepted(response.data.content.tcAccepted);
            }

        } catch (err) {
            console.log(err);
        }
    };

    const logout = async () => {
        setAuth({});
        localStorage.clear();
        navigate('/login');
    }

    const handleClick = () => {
        setCaretDown(!caretDown);
        setMenuOpen(!menuOpen)
    }

    const handleBlur = () => {
        setMenuOpen(false);
        setCaretDown(true);
    }

    const openChangePassword = (id, routePath) => {
        navigate('/' + routePath, { state: { id: id } });
    }

    return (
        <div>
            <div className="profile-link" onBlur={handleBlur}>
                <Button className="profile-button"  onClick={handleClick} >
                    <Row>
                        <Col sm="8">
                            <div className="profile">
                                <div ref={nameRef} style={{ display: "inline-block", whiteSpace: "nowrap" }}>{user.fullName} </div>
                            </div>
                        </Col>
                        <Col sm="4">
                            <div>
                                {caretDown ? <FaChevronDown style={{ height: "14px" }} /> : <FaChevronUp style={{ height: "2vh" }} />}
                            </div>
                        </Col>
                    </Row>
                </Button>
                <Collapse isOpen={menuOpen} className="profile-dropdown">
                    <div className="dropdown-menu-lg overflow-hidden p-0 dropdown-menu dropdown-menu-right show" id="settingsMenu">
                        <ul className="text-left bg-transparent list-group list-group-flush">
                            <li className="list-group-item p-0">
                                <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                    <li className="nav-item">
                                        <Link to="/welcome" className="nav-link ml-0"><FaHome /> Welcome</Link>
                                    </li>
                                </ul>
                            </li>
                            
                            {
                                role == 1 &&
                                    <li className="list-group-item p-0">
                                        {/* <span className="nav-link menu-setting-header">Settings </span> */}
                                        <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                            
                                            <li className="nav-item">
                                                <Link to="/externalorganisation" className="nav-link"><FaRegBuilding /> Organisations</Link>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/user" className="nav-link profile-dropdown-item"><FaRegUserCircle /> Users</a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/farm" className="nav-link"><FaWarehouse /> Farms</a>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/userfarm" className="nav-link"><FaLink /> User Farm Association</a>
                                            </li>
                                            {/*<li className="nav-item">*/}
                                            {/*    <a href="/subscriptions" className="nav-link"><FaBell /> Subscriptions</a>*/}
                                            {/*</li>*/}
                                            <li className="nav-item">
                                                <a href="/news" className="nav-link"><FaNewspaper /> News</a>
                                            </li>
                                        </ul>
                                    </li> 
                            }
                            <li className="list-group-item p-0">
                                <ul className="nav-neutral-primary flex-column nav nav-pills profile-dropdown">
                                    {
                                        pageSettingsAccess && tcAccepted &&
                                        <>
                                            <li className="nav-item">
                                                <Link to="/farmsettings" className="nav-link"><FaCog /> Farm Settings</Link>
                                            </li>
                                            <li className="nav-item">
                                                <a href="/accessmanager" className="nav-link"><FaStaylinked /> Access Manager</a>
                                            </li>
                                            <li className="nav-item">
                                                <Link to="/mapimport" className="nav-link"><FaFileImport /> Map Import</Link>
                                            </li>
                                            
                                        </>
                                    }
                                    {tcAccepted && user.isUserSubscriptionMenuAccess && <li className="nav-item">
                                                <Link to="/farm-subscription" className="nav-link"><FaBell /> Subscription</Link>
                                    </li>}
                                    {tcAccepted && 
                                        <li className="nav-item">
                                            <a href="/changepassword" onClick={(id, routePath) => openChangePassword(userId, 'changepassword')} className="nav-link"><FaKey /> Change Password</a>
                                        </li>
                                    }                                    
                                    <li className="nav-item">
                                        <button onClick={logout} className="nav-link profile-dropdown-logout logout"><FaDoorOpen /> Logout</button>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </Collapse>
            </div>
        </div>
    );
}

export default Profile